import { Button, Flex } from "emoreg";
import { Modal } from "emoreg/organisms/modal";
import { GenericModalInjectedProps } from "hassibot/component/modal";
import {
  APP_UPDATE_REQUIRED,
  BROADCAST_CHANNEL_APP_UPDATE,
  emitOnBroadcastChannel,
} from "startup/custom-broadcast-channel";

export const AppUpdateModalContent = (props: GenericModalInjectedProps<void>) => {
  const handleUpdate = () => {
    emitOnBroadcastChannel(BROADCAST_CHANNEL_APP_UPDATE, {
      type: APP_UPDATE_REQUIRED,
    });
    props.hideModal();
  };

  return (
    <Modal
      title="Mise à jour requise"
      footer={
        <Flex justifyContent="space-between" gap={16}>
          <Button variant="secondary" onClick={props.hideModal}>
            Fermer mes onglets manuellement
          </Button>
          <Button onClick={handleUpdate}>
            Mettre à jour l'application (données locales perdues)
          </Button>
        </Flex>
      }
    >
      Votre version de l'application est obsolète. Veuillez mettre à jour l'application. Pour cela
      fermez tous vos onglets actifs et relancez l'application. Ou vous pouvez cliquer sur le bouton
      pour recharger tous vos onglets. En cliquant sur ce bouton : <br />
      <br />
      ⚠️ vos données locales seront perdues (exemple : formulaire de debrief d'une visite en cours)
      <br />✅ vos données disponibles hors ligne sont préservées (documents non uploadés, interface
      de programmation de VEB, VEB)
    </Modal>
  );
};
